import { type Rule } from "antd/lib/form"
import moment from "moment"
import { i18n } from "~Shared/locales/i18n"
import { isEmptyString, isWhitespaceOnly } from "~Shared/utils/helper.utils"

const SEPA_SUBJECT_LINE_CHAR_LIMIT = 140

export const createPaymentConfirmationRules = (isScheduledPayment: boolean) => ({
    paymentExecutionDate: [
        {
            validator: (_rule, value: moment.Moment) => {
                if (isScheduledPayment && value.startOf("day").isBefore(moment().startOf("day"))) {
                    return Promise.reject(i18n.t("validation:cannot_be_in_past"))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    noSymbolAllowed: [
        {
            validator: (_rule, value: string) => {
                if (isEmptyString(value)) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (isWhitespaceOnly(value)) {
                    return Promise.reject(i18n.t("validation:no_whitespace_only"))
                }
                if (/^[A-Za-z0-9.,!@#$%^&*-+=_\-?\/\\()<>\[\]:;"'äöüÄÖÜß ]+$/g.test(value)) {
                    return Promise.resolve()
                }
                return Promise.reject(i18n.t("validation:subject_contains_unsupported_character"))
            },
        },
    ] as Array<Rule>,
    subjectLineCharacterLimit: [
        {
            validator: (_rule, value: string) => {
                if (value.length > SEPA_SUBJECT_LINE_CHAR_LIMIT) {
                    return Promise.reject(i18n.t("validation:max.string", { max: SEPA_SUBJECT_LINE_CHAR_LIMIT }))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
